import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { config } from '../config';
import { serviceAreas, milesFromOffice } from '../Contact/serviceAreas';

const CONTACT_FORM_LINK = `${config.appUrl}contact-us#service-area-map`;

const CourseLocations = () => {
  const locationsListRef = useRef(null);
  const isPausedRef = useRef(false);

  useEffect(() => {
    const locationsList = locationsListRef.current;
    if (!locationsList) return undefined;

    let animationFrame;
    let previousTimestamp;

    const scrollLocations = (timestamp) => {
      if (previousTimestamp === undefined) previousTimestamp = timestamp;
      const elapsed = timestamp - previousTimestamp;
      previousTimestamp = timestamp;

      if (
        !isPausedRef.current &&
        locationsList.scrollWidth > locationsList.clientWidth
      ) {
        locationsList.scrollLeft += elapsed * 0.08;
        if (locationsList.scrollLeft >= locationsList.scrollWidth / 2) {
          locationsList.scrollLeft = 0;
        }
      }

      animationFrame = requestAnimationFrame(scrollLocations);
    };

    animationFrame = requestAnimationFrame(scrollLocations);
    return () => cancelAnimationFrame(animationFrame);
  }, []);

  const pauseScrolling = () => {
    isPausedRef.current = true;
  };

  const resumeScrolling = () => {
    isPausedRef.current = false;
  };

  const handleViewAllAreas = () => {
    sessionStorage.setItem('courses-return-to-locations', 'true');
  };

  return (
    <section className="course-locations-section" id="course-locations-section">
      <div className="auto-container">
        <div className="course-locations-inner">
          <span className="course-locations-icon">
            <i className="bi bi-geo-alt-fill"></i>
          </span>
          <div className="course-locations-text">
            <h3>We Cover Leicester &amp; Surrounding Areas</h3>
            <p>
              We provide driving lessons across Leicester and nearby areas,
              subject to instructor availability.
            </p>
          </div>
        </div>

        <div
          ref={locationsListRef}
          className="course-locations-list"
          onMouseEnter={pauseScrolling}
          onMouseLeave={resumeScrolling}
          onFocus={pauseScrolling}
          onBlur={resumeScrolling}
        >
          {[...serviceAreas, ...serviceAreas].map((area, index) => (
            <Link
              key={`${area.name}-${index}`}
              to={CONTACT_FORM_LINK}
              className="course-location-chip"
            >
              <i className="bi bi-geo-alt-fill"></i>
              <span>
                <span className="course-location-name">{area.name}</span>
                <span className="course-location-distance">
                  {area.isOffice
                    ? 'Primary Area'
                    : `${milesFromOffice(area.position).toFixed(1)} miles`}
                </span>
              </span>
            </Link>
          ))}
        </div>

        <div className="course-locations-cta">
          <Link
            to={CONTACT_FORM_LINK}
            className="btn-view-all-areas"
            onClick={handleViewAllAreas}
          >
            View All Areas
          </Link>
        </div>
      </div>
    </section>
  );
};

export default CourseLocations;
